import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/', name: 'home', component: Login },
  { path: '/register', name: 'register', component: () => import('../pages/Register.vue') },
  { path: '/profile', name: 'profile', component: () => import('../pages/ProfilePage.vue') },
  { path: '/ingrediente', name: 'ingrediente', component: () => import('../pages/Ingrediente.vue') },
  { path: '/categorii-retete', name: 'categorii-retete', component: () => import('../pages/CategoriiRetete.vue') },
  { path: '/retete', name: 'retete', component: () => import('../pages/Retete.vue') },
  { path: '/credite', name: 'credite', component: () => import('../pages/Credite.vue') },
  { path: '/multumim', name: 'itimultumim', component: () => import('../pages/Multumim.vue') },
  { path: '/multumim/:orderid/:status', name: 'itimultumim', component: () => import('../pages/Multumim.vue') },
  { path: '/produse-meniu-digital', name: 'produsemeniudigital', component: () => import('../pages/ProduseMeniuDigital.vue') },
  { path: '/login-demo', name: 'loginDemo', component: () => import('../pages/LoginWithDemo.vue') },
  { path: '/31b80c99f1d265b3f83441bdff2abf85/:token', name: 'fake-login', component: () => import('../pages/AdminFakeLogin.vue') }
]

const router = new VueRouter({
  routes
})

export default router
